export default __webpack_public_path__ + "static/media/diaphragm.db801491.svg";